import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listSnapshotDetails = ({userIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('google/gmail/search', {
    userIds,
    folderId,
    snapshotDateTime,
    pagination,
    searchTerm: trimString(searchTerm)
  })
}

const listBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('google/gmail/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({
                          snapshotDateTime,
                          sourceIds,
                          searchTerm,
                          selectedIds,
                          outputFormat,
                          code,
                          extension,
                          storageDestinationId,
                          dataType,
                          storageDestinationType
                        }) => {
  return POST('google/gmail/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    outputFormat,
    extension,
    storageDestinationId,
    dataType,
    storageDestinationType
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/gmail/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null});
}

export {
  listSnapshotDetails,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
